import { Locales } from '@enums/locales';
import { Page, PagePost } from '@typings/page';

export const defaultHomepageSlug = 'overview';

export const emptyPage: Page = {
  brandguideKey: '',
  createdAt: new Date().toISOString(),
  deletedAt: null,
  key: '', // MUST be a blank string
  locale: Locales.EnUS,
  name: '',
  position: 0,
  slug: '',
  updatedAt: new Date().toISOString()
};

export const defaultPagePost: PagePost = {
  brandguideKey: '',
  locale: Locales.EnUS,
  name: 'Overview',
  position: 0,
  slug: defaultHomepageSlug
};
